export const dateFormat = 'DD-MM-YYYY';
export const timeFormat = 'HH:mm';
